import { Builder } from '@builder.io/sdk';
import dynamic from 'next/dynamic';
import { ARTICLE_SIDEBAR_DEFAULT_LIMIT, ARTICLE_SIDEBAR_NAME } from './ArticleSidebar.types';

const ArticleSidebar = dynamic(() => import('./ArticleSidebar').then((m) => ({ default: m.ArticleSidebar })));

const ArticleSidebarConfig = {
  name: ARTICLE_SIDEBAR_NAME,
  friendlyName: 'Article Sidebar',
  description:
    'A sidebar carousel showing articles one at a time with navigation arrows and a "More" button. Ideal for cross-linking between Guides and News pages.',
  inputs: [
    {
      name: 'title',
      type: 'string',
      friendlyName: 'Section Title',
      helperText: 'Title displayed above the carousel (e.g., "Guides" or "News")',
      defaultValue: 'Guides',
    },
    {
      name: 'tagVariant',
      type: 'string',
      friendlyName: 'Tag Color',
      helperText: 'Color variant for category tags.',
      defaultValue: 'primary',
      enum: ['primary', 'secondary'],
    },
    {
      name: 'moreLink',
      type: 'string',
      friendlyName: 'More Link URL',
      helperText: 'URL for the "More" button (e.g., "/guides" or "/news")',
      defaultValue: '/guides',
    },
    {
      name: 'moreLinkLabel',
      type: 'string',
      friendlyName: 'More Link Label',
      helperText: 'Label for the "More" button (e.g., "More guides" or "More news")',
      defaultValue: 'More guides',
    },
    {
      name: 'autoSelectLatest',
      type: 'boolean',
      friendlyName: 'Auto-select latest articles',
      helperText: 'When enabled, automatically shows the most recent articles. Disable to manually pick articles.',
      defaultValue: true,
    },
    {
      name: 'limit',
      type: 'number',
      friendlyName: 'Number of articles',
      helperText: `Maximum number of articles in the carousel. Default: ${ARTICLE_SIDEBAR_DEFAULT_LIMIT}`,
      defaultValue: ARTICLE_SIDEBAR_DEFAULT_LIMIT,
      min: 1,
      max: 10,
      showIf: 'options.get("autoSelectLatest") !== false',
    },
    {
      name: 'articles',
      type: 'list',
      friendlyName: 'Articles',
      helperText: 'Manually select which articles to display.',
      showIf: 'options.get("autoSelectLatest") === false',
      subFields: [
        {
          name: 'article',
          type: 'reference',
          model: 'article',
        },
      ],
    },
  ],
};

Builder.registerComponent(ArticleSidebar, ArticleSidebarConfig);
